import { FieldType } from '@/components/BlockEditorWidget/widgetFieldTypes.const';

export const SHOW_ACTION_SECTION_MINI_APPS = [FieldType.AIInput, FieldType.ImageEditor];
export const SHOW_WIDGET_LAYOUT_MINI_APPS = [FieldType.ImageEditor];

export const MULTI_FILE_VIEWER = 'multi_file_viewer';

export const DATE_TIME_TIMEZONE_OPTIONS = {
	automaticallyDetect: 0,
	letUserChoose: 1,
	setCustom: 2,
};
